import { useDispatch, useSelector } from "react-redux";
import { setFilterDatePieChart, setFilterDateSunburst } from "../helpers/helpersGraph";
import { setProjectCategories, setProjectLeaders, setProjectSize } from "../redux/slices/general/general";

export const useGeneralData = () => {
	const dispatch = useDispatch();
	const { projectCategoriesAll, projectLeadersAll, projectSizeAll } = useSelector((state) => state.general);

	let data = null;

	const fetchData = {
		categories: (selectYear = "") => {
			data = { name: "categorias", children: [] };
			const { dataSunburs } = setFilterDateSunburst(projectCategoriesAll.children, selectYear);
			data.children = dataSunburs;
			dispatch(setProjectCategories(data));
		},
		projectSize: (selectYear = "") => {
			const { dataPie } = setFilterDatePieChart(projectSizeAll, selectYear);
			data = dataPie;
			dispatch(setProjectSize(data));
		},
		leaders: (selectYear = "") => {
			data = { name: "lideres", children: [] };
			const { dataSunburs } = setFilterDateSunburst(projectLeadersAll.children, selectYear);
			data.children = dataSunburs;
			dispatch(setProjectLeaders(data));
		},
	};

	return {
		fetchData,
	};
};
